module.exports = __webpack_public_path__ + "static/media/sardar.0d0f5bcc.png";